<template>
  <div class="big-box">
    <img :src="backgroundImage" alt="" class="big-box-img" />
    <div class="big-body">
      <img :src="tapTopUrl" alt="" class="tap-top" />
      <div class="pd8">
        <!-- 主题文字 -->
        <div
          class="theme-word"
          :style="`color: ${customerPaperwork.titleColor};`"
        >
          <span>{{ customerPaperwork.title }}</span>
          <span>{{ customerPaperwork.desc }}</span>
        </div>
        <div class="time-word">
          活动距开始
          <span class="time-num">30</span>
          <span>天</span>
          <span class="time-num">12</span>
          <span>:</span>
          <span class="time-num">12</span>
          <span>:</span>
          <span class="time-num">12</span>
        </div>
        <div class="product-box">
          <div
            class="product-item"
            v-for="item in firstProduct"
            :key="item.skuId"
            :style="`background-image: url(${productBg})`"
          >
            <img :src="item.logo" alt="" class="product-img" />

            <div class="product-word">
              <div class="product-name">{{ item.skuName }}</div>
              <div class="product-price">￥{{ item.promoPrice }}</div>
            </div>
          </div>
        </div>
        <div class="product-box product-box2">
          <div
            class="product-item"
            v-for="item in secondProduct"
            :key="item.skuId"
            :style="`background-image: url(${productBg})`"
          >
            <img :src="item.logo" alt="" class="product-img" />

            <div class="product-word">
              <div class="product-name">{{ item.skuName }}</div>
              <div class="product-price">￥{{ item.promotionPrice }}</div>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <div class="btn-recomm" v-if="ruleDTO.recommendComboEnabled">
            <img :src="recommUrl" alt="" class="btn-img" />
            <div class="btn-word word-style1" :style="`color: ${customerPaperwork.recommendColor};`">推荐组合</div>
          </div>
          <div class="btn-main">
            <img :src="mainUrl" alt="" class="btn-img" />
            <div
              class="btn-word word-style2"
              :style="`color: ${customerPaperwork.btnColor};`"
            >
              打包袋
            </div>
          </div>
        </div>
        <!-- 优惠券列表 -->
        <div
          class="coupon-box"
          :style="`background-image: url(${couponRegionUrl})`"
          v-if="ruleDTO.couponEnabled"
        >
          <div class="coupon-list">
            <div
              class="coupon-item"
              :style="`background-image: url(${couponBg})`"
              v-for="item in couponList"
              :key="item.assetsId + item.title"
            >
              <div class="coupon-word-box">
                <div class="coupon-word">{{ item.title }}</div>
                <div class="coupon-price" v-if="item.price">￥{{ item.price }}</div>
              </div>
              <div class="coupon-btn">立即领取</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    productList: {
      type: Array,
      default: () => [],
    },
    couponList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentObj: {},
      currentPrize: [],
      currentIndex: 0,
      prizeList: [],
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
      inviteNumImg:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/yqrs_footer.png",
    };
  },
  computed: {
    tabUrl() {
      return this.customerPaperwork.tabUrl
        ? this.customerPaperwork.tabUrl
        : this.templateObj.url3;
    },
    btnUrl() {
      return this.customerPaperwork.btnUrl
        ? this.customerPaperwork.btnUrl
        : this.templateObj.url2;
    },
    productBg() {
      return this.customerPaperwork.url3 || this.templateObj.url3;
    },
    firstProduct() {
      //前10个商品
      return this.productList && this.productList.length > 0 ? this.productList.slice(0, 10) : [];
    },
    secondProduct() {
      //后10个商品
      return this.productList && this.productList.length > 0 ? this.productList.slice(10) : [];
    },
    mainUrl() {
      return this.customerPaperwork.url2 || this.templateObj.url2;
    },
    recommUrl() {
      return this.customerPaperwork.url4 || this.templateObj.url4;
    },
    couponRegionUrl() {
      return this.customerPaperwork.url5 || this.templateObj.url5;
    },
    couponBg() {
      const configJson = this.templateObj.configJson
        ? JSON.parse(this.templateObj.configJson)
        : { url6: "" };
      return this.customerPaperwork.url6 || configJson.url6;
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;
  // overflow: hidden;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
  .big-box-img {
    border-radius: 24px;
    width: 284px;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tap-top {
      padding-top: 10px;
      width: 100%;
    }
    .pd8 {
      width: 100%;
      height: 100%;
      margin-top: 18px;
      // padding: 8px;
      box-sizing: border-box;
      position: relative;
      .theme-word {
        // position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        // top: 18px;
        width: 100%;
        > span:first-child {
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 10px;
        }
        > span:last-child {
          font-size: 11px;
          opacity: 0.7;
        }
      }
      .time-word {
        margin-top: 12px;
        width: 100%;
        font-size: 8px;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;
        .time-num {
          display: inline-block;
          width: 15px;
          height: 13px;
          text-align: center;
          line-height: 13px;
          background: linear-gradient(33deg, #797162 0%, #373125 100%);
          border-radius: 2px 2px 2px 2px;
          font-size: 8px;
          color: #ffffff;
          margin: 0 4px;
        }
      }
      .product-box {
        width: 232px;
        position: absolute;
        top: 115px;
        left: 33px;
        padding: 16px 4px;
        display: flex;
        overflow: hidden;
        .product-item {
          width: 67px;
          height: 75px;
          flex-shrink: 0;
          border-radius: 12px 12px 12px 12px;
          background-repeat: no-repeat;
          background-size: 67px 75px;
          margin: 0 4px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-size: cover;
          .product-img {
            width: 24px;
            height: 24px;
          }
          .product-word {
            margin: 6px auto 0;
            width: 49px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 8px;
            color: #ffffff;
            line-height: 8px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            .product-name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .product-price {
              margin-top: 4px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      .product-box2 {
        top: 223px;
      }
      .btn-box {
        position: absolute;
        top: 330px;
        left: 33px;
        width: 232px;
        height: 57px;
        display: flex;
        justify-content: center;
        align-items: center;
        .btn-main,
        .btn-recomm {
          position: relative;
          .btn-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .btn-word {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .btn-main {
          width: 137px;
          height: 41px;
        }
        .btn-recomm {
          width: 80px;
          height: 41px;
        }
        .word-style1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 10px;
          color: #ffffff;
          line-height: 12px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .word-style2 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 10px;
          text-align: center;
          color: #ffffff;
        }
      }
      .coupon-box {
        position: absolute;
        top: 420px;
        left: 16px;
        width: 267px;
        height: 82px;
        background-repeat: no-repeat;
        background-size: 267px 82px;
        .coupon-list {
          margin-top: 8px;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow-x: auto;
          overflow-y: hidden;
          &::-webkit-scrollbar {
            width: 0;
            height: 0;
          }
          .coupon-item {
            flex-shrink: 0;
            position: relative;
            width: 80px;
            height: 39px;
            background-repeat: no-repeat;
            background-size: 100%;
            margin: 0 4px;
            .coupon-word-box {
              position: absolute;
              left: 0px;
              top: 0px;
              width: 60px;
              height: 35px;
              padding: 8px 0;

              .coupon-word {
                text-align: center;
                color: #333333;
                font-size: 8px;
              }
              .coupon-price {
                text-align: center;
                color: #333333;
                font-weight: 600;
                font-size: 10px;
                margin-top: 2px;
              }
            }
            .coupon-btn {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              width: 13px;
              height: 39px;
              line-height: 8px;
              position: absolute;
              font-size: 7px;
              color: #ffffff;
              // border: 1px solid #000;
              top: 0;
              right: 2px;
              padding: 3px 0;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
